.biel-search-filters {
  display: flex;
  gap: 8px;
  padding: 10px 0px;
}

.filter-button {
  padding: 8px 12px;
  border: 1px solid var(--biel-search-filter-border-color);
  border-radius: 5px;
  background-color: var(--biel-search-filter-bg-color);
  cursor: pointer;
  font-size: 14px;
  color: var(--biel-search-filter-color);
  font-family: var(--biel-font-family);
  transition: all 0.2s ease;
  white-space: nowrap;
}

.filter-button:hover {
  background-color: var(--biel-search-filter-hover-color);
}

.filter-button.selected {
  background-color: var(--biel-search-filter-selected-bg-color);
  color: var(--biel-search-filter-selected-color);
  border: 1px solid var(--biel-search-filter-selected-border-color);
}